import { render } from "./touchspin_Form.vue?vue&type=template&id=9a203222"
import script from "./touchspin_Form.vue?vue&type=script&lang=js"
export * from "./touchspin_Form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__